import resume1Preview from '../previews/resume1.png';
import resume2Preview from '../previews/resume2.png';
import resume3Preview from '../previews/resume3.png';
import resume6Preview from '../previews/resume6.png';
import resume11Preview from '../previews/resume11.png';
import resume12Preview from '../previews/resume12.png';
import resume13Preview from '../previews/resume13.png';
import resume18Preview from '../previews/resume18.png';

const PREVIEWS = {
  resume1: resume1Preview,
  resume2: resume2Preview,
  resume3: resume3Preview,
  resume6: resume6Preview,
  resume11: resume11Preview,
  resume12: resume12Preview,
  resume13: resume13Preview,
  resume18: resume18Preview,
};

const META = [
  { id: 'resume1', name: 'Classic Clean', tag: 'Classic' },
  { id: 'resume2', name: 'Academic CV', tag: 'Classic' },
  { id: 'resume3', name: 'Color Sidebar', tag: 'Modern' },
  { id: 'resume6', name: 'MaltaCV', tag: 'Modern' },
  { id: 'resume11', name: 'Bold Sections', tag: 'Modern' },
  { id: 'resume12', name: 'AltaCV', tag: 'Modern' },
  { id: 'resume13', name: 'Developer Resume', tag: 'Minimal' },
  { id: 'resume18', name: 'Memoir Sidebar', tag: 'Creative' },
];

export const templates = META.map((entry) => ({
  ...entry,
  preview: PREVIEWS[entry.id],
}));
